<template>
    <div class="common-module-page">
        <div class="page">
            <CommonTitle :title="modelTitle" @goMore="goMore" :showMore="list.length > 0" />
            <ul class="studio" v-if="list.length" v-loading="loading">
                <li class="studio-item" v-for="item in list" :key="item.id" @click="toDetail(item)">
                    <div class="list-item link">
                        <div class="list-item-img">
                            <img
                                src="~@/assets/img/workshop/briefing-icon.png"
                                class="img"
                                alt=""
                            />
                        </div>
                        <div class="list-item-content">
                            <div class="title">
                                <Ellipsis
                                    :content="item.title"
                                    width="240px"
                                    :lineHeight="20"
                                ></Ellipsis>
                            </div>
                            <div class="studio-info">
                                <div class="username-wrap">
                                    发布人：
                                    <div class="username f-color">
                                        <Ellipsis
                                            :content="item.publisher"
                                            width="100px"
                                            :lineHeight="20"
                                        ></Ellipsis>
                                    </div>
                                </div>
                                <div class="s-right">{{ formatDate(item.publishDate) }}</div>
                            </div>
                            <div class="studio-info">
                                <div class="s-user username-wrap" v-if="item.author">
                                    作者：
                                    <div class="username f-color">
                                        <Ellipsis
                                            :content="item.author"
                                            width="100px"
                                            :lineHeight="20"
                                        ></Ellipsis>
                                    </div>
                                </div>
                                <div class="s-right">
                                    浏览数：<span class="num f-color">{{
                                        formatNum(item.viewNum || 0)
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <BigNoData v-else class="no-data" url="no-lesson.png" info="暂无数据~" />
        </div>
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/index.vue';
import BigNoData from '@/components/no-data.vue';
import { ref, onMounted } from 'vue';
import { pageJump } from '@/global/location-transfer';
import { jumpHref } from '@/router/jumpHref.js';
import Ellipsis from '@/components/ellipsis.vue';
import dayjs from 'dayjs';

const props = defineProps({
    modelTitle: {
        type: String,
        default: '',
    },
});

const list = ref([]);

const loading = ref(false);
let filterData = ref({
    pageIndex: 1,
    pageSize: 6,
    sort: 1,
    isPortal: 1,
    type: 'article',
});

function formatDate(date = new Date()) {
    return dayjs(date).format('YYYY.MM.DD');
}

function formatNum(num) {
    if (Number(num) > 9999) {
        return '9999+';
    }
    return num;
}

function getList() {
    loading.value = true;
    G_transmit('workShopContentList', {
        name: 'workShopContentList',
        data: {
            ...filterData.value,
        },
        message: false,
    })
        .then(({ data, status: { code } }) => {
            if (code === 200) {
                list.value = (data && data.rows) || [];
            }
            loading.value = false;
        })
        .catch(err => {
            console.log('error', err);
            loading.value = false;
        });
}

// 跳转详情
function toDetail(item = {}) {
    pageJump(jumpHref.studio.squareDetail(item.id, 'article', item.id), true);
}

function goMore() {
    pageJump(jumpHref.studio.teachingStudioDynamics());
}

onMounted(() => {
    getList();
});
</script>

<style lang="scss" scoped>
.ss-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 2px;
}
@each $index in 0, 1, 2 {
    .ss-icon-#{$index} {
        background: url('~@/assets/img/home/shop#{$index}@2x.png') no-repeat;
        background-size: 16px 16px;
    }
}
.common-module-page {
    // width: 100vw;
    background: #ffffff;
    // padding-bottom: 40px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
    .list-item {
        display: flex;
        color: #000;
    }
    .list-item-img {
        width: 72px;
        height: 72px;
        margin-right: 15px;

        .img {
            width: 100%;
            height: 100%;
        }
    }
    .studio {
        display: flex;
        font-size: 16px;
        flex-wrap: wrap;
    }
    .studio-item {
        display: flex;
        margin-right: 24px;
        margin-top: 24px;
        width: 384px;
        height: 110px;
        padding: 15px 15px 23px;
        border-radius: 4px;
        border: 1px solid #e0e2e4;
        &:nth-child(3n) {
            margin-right: 0;
        }
        &:hover {
            .title {
                color: var(--home-main-color);
            }
            border: 1px solid var(--home-main-color);
        }
    }
    .title {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
    }
    .studio-info {
        cursor: pointer;
        font-size: 12px;
        color: #999;
        margin-top: 6px;
        display: flex;
        .username-wrap {
            display: flex;
        }
        .s-user {
            width: 148px;
        }
        .s-right {
            color: #999999;
        }
        .f-color {
            color: #222222;
        }
    }
}
</style>
